import type { Booking, WaitlistEntry } from '@/api/types'

/**
 * 预约 Mock 数据 (BOOK-01)
 * 关联W2教学场次: ts-001 ~ ts-012
 * 状态覆盖: PENDING / CHECKED_IN / CANCELLED / NOSHOW / LATE / LEAVE
 * Q4决策: 签到/请假/旷课/迟到同时生成Attendance记录
 * 第二轮: 加consumptionAmount(课消金额)+sessionTime(课程时间)
 */

export const mockBookings: Booking[] = [
  {
    id: 'bk-001',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-003',
    subjectId: 'tpl-001',
    customerId: 'cu-001',
    customerName: '赵小明',
    accountId: 'ea-001',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'PENDING',
    bookedAt: '2025-10-15T08:00:00+08:00',
    lastActionAt: '2025-10-15T08:00:00+08:00',
    amountMinor: 15000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-18T09:00:00Z',
    idempotencyKey: 'mock-bk-001',
    createdAt: '2025-10-15T08:00:00+08:00',
    updatedAt: '2025-10-15T08:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'bk-002',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-005',
    subjectId: 'tpl-002',
    customerId: 'cu-002',
    customerName: '蒋红',
    accountId: 'ea-002',
    entitlementId: 'etpl-002',
    entitlementName: '私教体能课卡5次',
    deductCount: 1,
    status: 'PENDING',
    bookedAt: '2025-10-13T13:00:00+08:00',
    lastActionAt: '2025-10-13T13:00:00+08:00',
    amountMinor: 20000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-13T14:00:00Z',
    idempotencyKey: 'mock-bk-002',
    createdAt: '2025-10-13T13:00:00+08:00',
    updatedAt: '2025-10-13T13:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'bk-003',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-006',
    subjectId: 'tpl-003',
    customerId: 'cu-003',
    customerName: '李东',
    accountId: 'ea-003',
    entitlementId: 'etpl-003',
    entitlementName: '足球课卡10次',
    deductCount: 1,
    status: 'CHECKED_IN',
    bookedAt: '2025-10-05T09:30:00+08:00',
    lastActionAt: '2025-10-05T11:10:00+08:00',
    amountMinor: 18000,
    currency: 'CNY',
    consumptionAmount: 18000,
    sessionTime: '2025-10-05T10:00:00Z',
    idempotencyKey: 'mock-bk-003',
    createdAt: '2025-10-05T09:30:00+08:00',
    updatedAt: '2025-10-05T11:10:00+08:00',
    createdBy: 'u-teacher-002',
    updatedBy: 'system',
  },
  {
    id: 'bk-004',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-001',
    subjectId: 'tpl-001',
    customerId: 'cu-004',
    customerName: '张玲',
    accountId: 'ea-001',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'CHECKED_IN',
    bookedAt: '2025-10-04T08:30:00+08:00',
    lastActionAt: '2025-10-04T10:10:00+08:00',
    amountMinor: 15000,
    currency: 'CNY',
    consumptionAmount: 15000,
    sessionTime: '2025-10-04T09:00:00Z',
    idempotencyKey: 'mock-bk-004',
    createdAt: '2025-10-04T08:30:00+08:00',
    updatedAt: '2025-10-04T10:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'bk-005',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-008',
    subjectId: 'tpl-005',
    customerId: 'cu-005',
    customerName: '刘洋',
    accountId: 'ea-004',
    entitlementId: 'etpl-004',
    entitlementName: '游泳储值卡',
    deductCount: 1,
    status: 'NOSHOW',
    bookedAt: '2025-10-08T15:30:00+08:00',
    lastActionAt: '2025-10-08T17:00:00+08:00',
    amountMinor: 12000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-08T16:00:00Z',
    idempotencyKey: 'mock-bk-005',
    createdAt: '2025-10-08T15:30:00+08:00',
    updatedAt: '2025-10-08T17:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-teacher-001',
  },
  {
    id: 'bk-006',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-007',
    subjectId: 'tpl-003',
    customerId: 'cu-006',
    customerName: '陈静',
    accountId: 'ea-003',
    entitlementId: 'etpl-003',
    entitlementName: '足球课卡10次',
    deductCount: 0,
    status: 'CANCELLED',
    bookedAt: '2025-10-11T09:00:00+08:00',
    lastActionAt: '2025-10-11T14:00:00+08:00',
    amountMinor: 18000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-12T10:00:00Z',
    idempotencyKey: 'mock-bk-006',
    createdAt: '2025-10-11T09:00:00+08:00',
    updatedAt: '2025-10-11T14:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'bk-007',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-009',
    subjectId: 'tpl-005',
    customerId: 'cu-004',
    customerName: '张玲',
    accountId: 'ea-004',
    entitlementId: 'etpl-004',
    entitlementName: '游泳储值卡',
    deductCount: 1,
    status: 'PENDING',
    bookedAt: '2025-10-14T15:00:00+08:00',
    lastActionAt: '2025-10-14T15:00:00+08:00',
    amountMinor: 12000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-15T16:00:00Z',
    idempotencyKey: 'mock-bk-007',
    createdAt: '2025-10-14T15:00:00+08:00',
    updatedAt: '2025-10-14T15:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'bk-008',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-010',
    subjectId: 'tpl-001',
    customerId: 'cu-007',
    customerName: '杨光',
    accountId: 'ea-005',
    entitlementId: 'etpl-005',
    entitlementName: '年度会员卡',
    deductCount: 1,
    status: 'PENDING',
    bookedAt: '2025-10-19T08:00:00+08:00',
    lastActionAt: '2025-10-19T08:00:00+08:00',
    amountMinor: 15000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-20T09:00:00Z',
    idempotencyKey: 'mock-bk-008',
    createdAt: '2025-10-19T08:00:00+08:00',
    updatedAt: '2025-10-19T08:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'bk-009',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-002',
    subjectId: 'tpl-001',
    customerId: 'cu-001',
    customerName: '赵小明',
    accountId: 'ea-001',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'CHECKED_IN',
    bookedAt: '2025-10-11T08:30:00+08:00',
    lastActionAt: '2025-10-11T10:10:00+08:00',
    amountMinor: 15000,
    currency: 'CNY',
    consumptionAmount: 15000,
    sessionTime: '2025-10-11T09:00:00Z',
    idempotencyKey: 'mock-bk-009',
    createdAt: '2025-10-11T08:30:00+08:00',
    updatedAt: '2025-10-11T10:10:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'bk-010',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-011',
    subjectId: 'tpl-001',
    customerId: 'cu-007',
    customerName: '杨光',
    accountId: 'ea-005',
    entitlementId: 'etpl-005',
    entitlementName: '年度会员卡',
    deductCount: 1,
    status: 'PENDING',
    bookedAt: '2025-10-26T08:00:00+08:00',
    lastActionAt: '2025-10-26T08:00:00+08:00',
    amountMinor: 15000,
    currency: 'CNY',
    consumptionAmount: 0,
    sessionTime: '2025-10-27T09:00:00Z',
    idempotencyKey: 'mock-bk-010',
    createdAt: '2025-10-26T08:00:00+08:00',
    updatedAt: '2025-10-26T08:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]

/**
 * 排队 Mock 数据
 * Q决策: 状态简化为3种 — 排队中(QUEUED)/已过期(EXPIRED)/已取消(CANCELLED)
 */

export const mockWaitlist: WaitlistEntry[] = [
  {
    id: 'wl-001',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-003',
    subjectId: 'tpl-001',
    customerId: 'cu-005',
    customerName: '刘洋',
    accountId: 'ea-006',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'QUEUED',
    queuedAt: '2025-10-16T10:00:00+08:00',
    lastActionAt: '2025-10-16T10:00:00+08:00',
    invitedAt: null,
    expireAt: null,
    createdAt: '2025-10-16T10:00:00+08:00',
    updatedAt: '2025-10-16T10:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'wl-002',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-007',
    subjectId: 'tpl-003',
    customerId: 'cu-008',
    customerName: '黄磊',
    accountId: 'ea-007',
    entitlementId: 'etpl-004',
    entitlementName: '游泳储值卡',
    deductCount: 1,
    status: 'QUEUED',
    queuedAt: '2025-10-11T08:00:00+08:00',
    lastActionAt: '2025-10-12T09:00:00+08:00',
    invitedAt: '2025-10-12T09:00:00+08:00',
    expireAt: '2025-10-12T09:30:00+08:00',
    createdAt: '2025-10-11T08:00:00+08:00',
    updatedAt: '2025-10-12T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'wl-003',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-009',
    subjectId: 'tpl-005',
    customerId: 'cu-005',
    customerName: '刘洋',
    accountId: 'ea-006',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'QUEUED',
    queuedAt: '2025-10-14T16:00:00+08:00',
    lastActionAt: '2025-10-14T16:00:00+08:00',
    invitedAt: null,
    expireAt: null,
    createdAt: '2025-10-14T16:00:00+08:00',
    updatedAt: '2025-10-14T16:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
  {
    id: 'wl-004',
    brandId: 'b-001',
    campusId: 'c-002',
    sessionId: 'ts-010',
    subjectId: 'tpl-001',
    customerId: 'cu-008',
    customerName: '黄磊',
    accountId: 'ea-007',
    entitlementId: 'etpl-004',
    entitlementName: '游泳储值卡',
    deductCount: 1,
    consumptionAmount: 0,
    sessionTime: '2025-10-20T09:00:00Z',
    status: 'EXPIRED',
    queuedAt: '2025-10-18T10:00:00+08:00',
    lastActionAt: '2025-10-19T08:30:00+08:00',
    invitedAt: '2025-10-19T08:00:00+08:00',
    expireAt: '2025-10-19T08:30:00+08:00',
    createdAt: '2025-10-18T10:00:00+08:00',
    updatedAt: '2025-10-19T08:30:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'system',
  },
  {
    id: 'wl-005',
    brandId: 'b-001',
    campusId: 'c-001',
    sessionId: 'ts-003',
    subjectId: 'tpl-001',
    customerId: 'cu-006',
    customerName: '陈静',
    accountId: 'ea-006',
    entitlementId: 'etpl-001',
    entitlementName: '篮球课卡10次',
    deductCount: 1,
    status: 'CANCELLED',
    queuedAt: '2025-10-15T14:00:00+08:00',
    lastActionAt: '2025-10-16T09:00:00+08:00',
    invitedAt: null,
    expireAt: null,
    createdAt: '2025-10-15T14:00:00+08:00',
    updatedAt: '2025-10-16T09:00:00+08:00',
    createdBy: 'u-consultant-001',
    updatedBy: 'u-consultant-001',
  },
]
